import React from 'react';
import Holidays from '../../company/Holidays';

const Holiday = () => {
  return (
    <div>
      <Holidays readOnly />
    </div>
  );
};

export default Holiday;
